import { render, staticRenderFns } from "./SupplierTools.vue?vue&type=template&id=3535624c&scoped=true&"
import script from "./SupplierTools.vue?vue&type=script&lang=js&"
export * from "./SupplierTools.vue?vue&type=script&lang=js&"
import style0 from "./SupplierTools.vue?vue&type=style&index=0&id=3535624c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3535624c",
  null
  
)

export default component.exports